<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import BorcDetayModal from '../customer/modals/payment_history';

export default {
  page: {
    title: "Fatura Makbuz Ara",
    meta: [
      { 
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    BorcDetayModal
  },
  data() {
    return {  
        details:[],
        title: "FATURA MAKBUZ ARA",
        items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "FATURA MAKBUZ ARA",
          active: true,
        },
      ],
      nfnum:{},
      isLoading: false,
      detailSearch:true,
      total:0,
      form:{ 
        tur:'',
        fullname:'',
        mfno:''
      },
      list: {},
      ilList:[],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {
        },
        sort: [
          {
            field: '',
            type: '',
          },
        ],
        page: 1,
        perPage: 250,
      },
      currentPage: 0,
      selected: 0,
      pageLength: 0,
        url: "/get-balances",
        paginationOptions: {
        enabled: true,
        dropdownAllowAll: false,
        perPage: 250,
        setCurrentPage: 1,
        perPageDropdown: [250, 500, 1000],
        nextLabel: 'Sonraki',
        prevLabel: 'Önceki',
        rowsPerPageLabel: 'Kayıt Göster',
        ofLabel: 'of',
        pageLabel: 'sayfa', // for 'pages' mode
        infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
      },
      openRightDrawer: false,
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
     columns: [   
       {
          label: 'Basıldı mı?',
          field: this.basim,
        },
        {
          label: 'Kullanıcı Adı',
          field: 'username',
        },
        {
          label: 'İsim Soyisim',
          field: this.fullname,
          sortable: false,
        },
        {
          label: 'Fatura / Makbuz No',
          field:  'nfnum',
          html: true,
          sortable: false,
        },
        {
          label: 'İşlem Tarihi',
          field: 'transaction_date',
          sortable: false,
        },        
        {
          label: 'Açıklama',
          field: 'main_explaine',
        },
        {
          label: 'Tutar',
          field: this.amount
        }
      ],
    };
  },
  mounted() {
    this.loadItems()
    this.ilListesi()
  },
  methods: {
    fullname(obj){
      return obj.fname + ' ' + obj.lname
    },
    basim(obj){
      return obj.printed == 0  ? 'Hayır' : 'Evet'
    },
    amount(obj){
      return this.$paraFormat(obj.amount)
    }, 
    async ilListesi(){
      const response = await this.$http.post(`/address/il/0`)
      this.ilList = response.data;
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
        this.info = response.info
        this.total = response.total

        response.rows.map((e,i)=>{
          this.nfnum[i] =  e.invoice_num  
               
        })
    })
    },
    getFromServer() {
      return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.data,
              info: res.data.info,
              totalRecords: res.data.total,
              pageLength: res.data.last_page,
              currentPage: res.data.current_page,
              total: res.data.total,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
   
    detay(props){
       this.list = props
       this.$parent.$bvModal.show('payment_history_modal')
    },
    async excelExport() {
        const currentDate = new Date();

        const filename = `${currentDate.getFullYear()}${('0' + (currentDate.getMonth() + 1)).slice(-2)}${('0' + currentDate.getDate()).slice(-2)}${('0' + currentDate.getHours()).slice(-2)}${('0' + currentDate.getMinutes()).slice(-2)}${('0' + currentDate.getSeconds()).slice(-2)}_Musteri_Fark_Listesi.xlsx`;

        this.$http.post('/reports/borclu-musteriler?excel=true', this.serverParams, { responseType: 'blob' })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            link.setAttribute('type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
    },

    faturaNoKaydet(idx){
      this.$http.put('/balances', { invoice_num : this.nfnum[idx], id: this.rows[idx].id })
      .then(() =>  this.$set(this.rows[idx], 'invoice_num', this.nfnum[idx]))

      // eslint-disable-next-line no-console
      console.log(this.nfnum[idx], idx, this.rows[idx])
    },

    filter(){
      this.updateParams({columnFilters : {...this.form}});
      this.loadItems()
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <BorcDetayModal :data="list" />
      <div class="row mb-3">
        <div class="col-xl-4">
            <div class="row">
              <div class="col-md-12 mb-3">
                  <label class="d-flex justify-content-between">İşlem Tarih Aralığı
                  <span 
                      v-if="form.startdate || form.startdateend" 
                      class="text-danger" 
                      @click="form.startdate= '' ;form.startdateend= ''">
                    </span>
                  </label>
                  <div class="input-group">
                  <input type="date" class="form-control" @change="filter()" v-model="form['startdate']">
                  <button style="border:0;background: transparent;">  - </button>
                  <input type="date" class="form-control" @change="filter()"  v-model="form['startdateend']">
                  </div>
              </div>
          </div>
        </div>
        <div class="col-xl-2">
          <div class="mb-3">
            <label>Tür</label>
            <select v-model="form.tur" class="form-select" @change="filter()">
              <option value="">Hepsi</option>
              <option value="basilanlar">Tüm Basılanlar</option>
              <option value="makbuz">Makbuz Basılan</option>
              <option value="fatura">Fatura Basılanlar</option>
              <option value="basilmayan">Hiç Basılmayanlar</option>
              <option value="numaralandirilmayan">Numaralandırılmayanlar</option>
            </select>
          </div>
        </div>
        <div class="col-xl-3">
          <div class="mb-3">
            <label>Makbuz / Fatura No</label>
            <input type="text" v-model="form.mfno" @input="filter()" class="form-control" />
          </div>
        </div>
        <div class="col-xl-3">
          <div class="mb-3">
            <label>Müşteri İsmi </label>
            <input type="text" v-model="form.fullname" @input="filter()" class="form-control" />
          </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <vue-good-table
                mode="remote"
                :line-numbers="true"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{enabled: false}"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <div class="px-3" slot="table-actions">
                   Toplam Alacak:{{ total }}
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span v-if="props.column.field === 'nfnum'">
                     <div class="input-group input-group-sm">
                        <span class="input-group-text" style="width:80px" >{{ props.row.direction == 1 ? 'Makbuz No:' : 'Fatura No:' }}</span>
                        <input type="text" style="width:20px" class="form-control form-control-sm" v-model="nfnum[props.index]" />
                        <button :class="`btn btn-sm btn-outline-${nfnum[props.index] == props.index ? 'warning' : 'success'}`" type="button" @click="faturaNoKaydet(props.index)"> 
                          <span v-if="nfnum[props.index] == props.index">Güncelle</span>
                          <span v-else>Kaydet</span>
                        </button>
                      </div>
                  </span>
                </template>
            </vue-good-table>
        </div>
    </div>
  </Layout>
</template>